import { Subscription, Consumer } from "@rails/actioncable";
import {
  EventEmitter,
  FormAssistantEvents,
  AssistantStreamChunkEvent,
  AssistantStreamEndEvent,
  AssistantFullResponseEvent,
  AssistantToolCallsEvent,
  AssistantTriggerActionEvent,
  AssistantErrorEvent,
} from "@getregistered/greg-editors";
import {getSubscription} from "../actionCableConsumerPool";

type StreamMessage =
  | AssistantStreamChunkEvent
  | AssistantStreamEndEvent
  | AssistantFullResponseEvent
  | AssistantToolCallsEvent
  | AssistantTriggerActionEvent
  | AssistantErrorEvent;

export class FormAssistantChannelControl {
  formAssistantChannelSubscription: Subscription;
  events: EventEmitter<FormAssistantEvents>;

  constructor(
    consumer: Consumer,
    id: number,
    events: EventEmitter<FormAssistantEvents>
  ) {
    this.formAssistantChannelSubscription = getSubscription(
      consumer,
      "FormAssistantChannel",
      id,
      {
        received: this.receiveAssistanceUpdate.bind(this),
      }
    )
    this.events = events;
  }

  receiveAssistanceUpdate(data: StreamMessage): void {
    if(data === null) {
      return;
    }

    if (data.type === "stream_end") {
      this.events.emit('assistant.stream_end', data);
    } else if (data.type === "trigger_action") {
      this.events.emit('assistant.trigger_action', data);
    } else if (data.type === "tool_calls") {
      this.events.emit('assistant.tool_calls', data);
    } else if (data.type === "full_response") {
      this.events.emit('assistant.full_response', data);
    } else if (data.type === "stream_chunk") {
      this.events.emit('assistant.stream_chunk', data);
    } else if (data.type === "error") {
      this.events.emit('assistant.error', data);
    }
  }

  askAssistant = (message: string, chatId?: string, options?: { role?: string }): void => {
    this.formAssistantChannelSubscription.perform("ask", { message, chat_id: chatId, role: options?.role });
  };

  tellAssistant = (message: string, chatId?: string, options?: { role?: string }): void => {
    this.formAssistantChannelSubscription.perform("tell", { message, chat_id: chatId, role: options?.role });
  };

  updateMessageStatus = (chatId: string, messageId: string, status: string): void => {
    this.formAssistantChannelSubscription.perform("update_message_status", { chat_id: chatId, message_id: messageId, status });
  };

  dispose() {
    this.formAssistantChannelSubscription?.unsubscribe()
  }
}
